/* eslint-disable indent */
import React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { KeyboardArrowDownTwoTone } from '@mui/icons-material'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  root: {},
  option: {
    ...typography.body.xs,
    color: palette.common.black,
    '&  span': {
      marginRight: 12,
      fontSize: '1.5em'
    }
  }
}))

const AutocompleteSelect = props => {
  const classes = useStyles(props)
  const { classes: remove, onChange, placeholder, autoFocus, ...rest } = props
  const { 'data-test': dataTest } = rest
  const handleChange = (evt, newValue, reason) => {
    onChange(newValue)
  }

  return (
    <Autocomplete
      autoHighlight
      getOptionLabel={option => option.label}
      renderInput={params => (
        <TextField
          {...params}
          variant='standard'
          placeholder={placeholder}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            'data-test': `${dataTest}-input`,
            autoFocus
          }}
        />
      )}
      onChange={handleChange}
      popupIcon={<KeyboardArrowDownTwoTone />}
      classes={{ root: classes.root, option: classes.option }}
      {...rest}
    />
  )
}

export default AutocompleteSelect
